<h3 class="mode-title">Embed this Gallery</h3>

<div
  class="rounded-banner warn"
  *ngIf="gallery.public_access === 'no_access' && ('gallery.embed-gallery' | permissions : gallery)"
>
  <app-svg src="/assets/icons/globe-disabled.svg"></app-svg>
  <span>Link access is disabled.</span>
  <button
    appButton
    name="enable-access"
    location="share-gallery-embed"
    color="warn"
    shape="round"
    height="1"
    (click)="onChangeMode.emit('link')"
  >
    Manage
  </button>
</div>

<div class="rounded-banner" *ngIf="'!gallery.embed-gallery' | permissions : gallery">
  <app-svg src="/assets/icons/sparks.svg"></app-svg>
  <span>Upgrade to Picflow Plus</span>
  <a
    appButton
    name="upgrade"
    location="share-gallery-embed"
    [routerLink]="['/a/pricing']"
    color="primary"
    shape="round"
    height="1"
  >
    Upgrade
  </a>
</div>

<div
  class="main-container"
  [class.disabled]="gallery.public_access === 'no_access' || ('!gallery.embed-gallery' | permissions : gallery)"
>
  <div class="fake-textarea">
    {{ embedCode }}
  </div>

  <div class="embed-footer">
    <app-context-menu name="embed-settings" [options]="{ width: '240px' }">
      <button
        appButton
        name="embed-settings"
        location="share-gallery-embed"
        color="simple"
        weight="bold"
        [hasIcon]="true"
        contextButton
      >
        <app-svg src="/assets/icons/code-circle.svg"></app-svg>
        <span>Embed Settings</span>
        <app-svg src="/assets/icons/chevron-down.svg" size="0"></app-svg>
      </button>

      <div contextContent>
        <label for="option-asset-view" class="embed-option">
          <div>Asset View</div>
          <div class="switch small" appTransitionPreventor>
            <input
              type="checkbox"
              id="option-asset-view"
              [(ngModel)]="options.allowAssetView"
              (ngModelChange)="onEmbedChange()"
            />
            <label for="option-asset-view" data-test-id="option-asset-view"></label>
          </div>
        </label>

        <label for="option-cover" class="embed-option">
          <div>Show Cover</div>
          <div class="switch small" appTransitionPreventor>
            <input type="checkbox" id="option-cover" [(ngModel)]="options.addCover" (ngModelChange)="onEmbedChange()" />
            <label for="option-cover" data-test-id="option-cover"></label>
          </div>
        </label>
      </div>
    </app-context-menu>

    <div class="spacer"></div>
    <button
      appButton
      name="copy-embed"
      location="share-gallery-embed"
      color="primary"
      [share]="embedCode"
      (onCopied)="onCopy()"
      height="3"
      shape="round"
      size="3"
      weight="bold"
      spacing="4"
      [class.disabled]="gallery.public_access === 'no_access'"
    >
      Copy
    </button>
  </div>
</div>
